import BreadCrumb from "../common/BreadCrumb";

const BreadCrumbBanner = () => {
  return (
    <section className="inner_page_breadcrumb">
      <div className="container">
        <div className="row">
          <div className="banner-message col-xl-6">
          <h1>About Us</h1>
          </div>
          
        </div>
      </div>
    </section>
  );
};

export default BreadCrumbBanner;
